import { Box, Divider, Flex, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, VStack, StackDivider, Image, Text, useMediaQuery } from '@chakra-ui/react';
import React from 'react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { ActivityTable } from './style';
import MorePanel from '../../../Component/MorePanel';
import { lineBreakToBr, slashToBr } from '../../../util';
import { theme } from '../../../assets/style/theme';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  data:any;
};

function ParticipationContentItemActivityGallery({ data }: Props) {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
    <VStack
      divider={<StackDivider borderColor='b.lg' />}
      spacing={5}
      align='stretch'
    >
      {
        data.map((item:any, index:number) => (
          <Box key={index}>
            <Flex direction={flexBoxDirection}>
              <Heading size="xl" w="280px" pb={isMobile ? '4' : '0'}>{item?.meta?.activity_year}</Heading>
              <Image src={item.featured_medium} alt={item.title} w="2xs" objectFit="cover" />
              <Box ml={isMobile ? '0' : '8'} pt={isMobile ? '4' : '0'}>
                <Heading size="2xl" color="b.bk" pb="4" lineHeight="1.6" dangerouslySetInnerHTML={{ __html: slashToBr(item.title) }}></Heading>
                <Text>
                  <div dangerouslySetInnerHTML={ {__html: lineBreakToBr(item.content)} } />
                </Text>
              </Box>
            </Flex>
          </Box>
        ))
      }
    </VStack>
    </>
  );
}

ParticipationContentItemActivityGallery.defaultProps = {
};

export default ParticipationContentItemActivityGallery;
